import Resource from './Resource';

class UserParam extends Resource {
	constructor() {
		super('master/userParam');

		this.notifications = {
			save: () => ({
				title: 'default.updated',
				body: 'updated.userParam',
				style: 'success',
				icon: 'check',
				type: 'body'
			}),
			saveError: () => ({
				title: 'default.error',
				body: 'saveError.userParam',
				style: 'error',
				icon: 'times',
				type: 'body'
			})
		} as any;
	}

	save(
		paramId: number,
		value: unknown,
		options: { skipNotification?: boolean; skipErrorNotification?: boolean } = {}
	) {
		if (value === undefined || !paramId) {
			return Promise.reject('No params');
		}

		return this._putRequest(String(paramId), { value }, { methodName: 'save', ...options });
	}
}

export default new UserParam();
